import { cn } from '@repo/ui/lib/utils'

/** Names a pane of a multi-pane menu, such as Add column, so the panes read as steps from left to right. */
export const PaneTitle = ({ children, className }: { children: string; className?: string }) => (
  <h3 className={cn('px-2 pt-2 pb-1 text-xs font-medium text-muted-foreground', className)} data-sentry-component="PaneTitle" data-sentry-source-file="pane-title.tsx">
    {children}
  </h3>
)
